import ApiPage from '../api-page';


class PreviewApplicationPage extends ApiPage {

}


export default PreviewApplicationPage;
